module.exports = __webpack_public_path__ + "img/podcast-expert.10ec8dc6.png";